import Splide from "@splidejs/splide"

export default function initSplide() {
  const carousels = document.querySelectorAll(".splide")
  if (carousels.length === 0) return

  window.Splide = Splide

  carousels.forEach((carousel) => {
    let options = {}

    if (carousel.classList.contains("loop")) {
      options = {
        type: "loop",
        perPage: 2.5,
        focus: "center",
        pagination: false,
      }
    }

    const splide = new Splide(carousel, options).mount()

    const filterButtons = carousel.parentNode.parentNode.getElementsByClassName("filterButton")
    const offerFilterButtons = carousel.parentNode.parentNode.getElementsByClassName("offerFilterButtons")

    if (filterButtons) {
      for (const element of filterButtons) {
        element.addEventListener("click", () => {
          splide.refresh()
        })
      }
    }

    if (offerFilterButtons) {
      for (const element of offerFilterButtons) {
        element.addEventListener("click", () => {
          splide.refresh()
        })
      }
    }

    const select = carousel.parentNode.parentNode.querySelector("[id=select]")
    if (select) {
      select.addEventListener("change", () => {
        splide.go(0)
        splide.refresh()
      })
    }
  })
}
